import { render } from "./CarCombo.vue?vue&type=template&id=5de84a3c&scoped=true"
import script from "./CarCombo.vue?vue&type=script&lang=js"
export * from "./CarCombo.vue?vue&type=script&lang=js"

import "./CarCombo.vue?vue&type=style&index=0&id=5de84a3c&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de84a3c"]])

export default __exports__